import React from 'react';

import { EImageSource } from '@sharedComponents/Images';
import { ProductItemBodyWrapper } from '@sharedComponents/Products';
import { ReactFCV } from '@types';
import { OUT_OF_STOCK } from '@utils/constants';

import { messages } from '../../messages';

import { Wrapper, StyledImage } from './styled';

interface IDiscoverySampleProductProps {
  brandName: string;
  name: string;
  annotation: string;
  imageUrl: string;
  stockAvailability: string;
}

export const DiscoverySampleProduct: ReactFCV<IDiscoverySampleProductProps> = ({
  brandName,
  name,
  annotation,
  imageUrl,
  stockAvailability,
}) => {
  return (
    <Wrapper>
      <StyledImage url={imageUrl} sourceKey={EImageSource.ORDER} />
      <ProductItemBodyWrapper
        brand={brandName}
        name={name}
        subName={annotation}
        disabled={stockAvailability === OUT_OF_STOCK}
        maximumQuantity={1}
        itemQuantity={1}
        messages={messages}
      />
    </Wrapper>
  );
};
